<template>
  <div>
    <div v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </div>
  <div v-if="!loading">
    <ListCity @cid="getcid" :cityname="cityname" :provincename="provincename"></ListCity>
    <el-tabs v-model="type" @tab-click="handleClick">
      <el-tab-pane label="最新发布" :disabled="type==='4'" name="4"></el-tab-pane>
      <el-tab-pane label="本周热门" :disabled="type==='1'" name="1"></el-tab-pane>
      <el-tab-pane label="本月热门" :disabled="type==='2'" name="2"></el-tab-pane>
      <el-tab-pane label="上月热门" :disabled="type==='3'" name="3"></el-tab-pane>
    </el-tabs>
    <information :page="true" :pageNum="page" :fullscreenLoading="fullscreenLoading" :data="data" :total="total"></information>
  </div>
  </div>
</template>

<script>
import ListCity from '../widget/listcity'
import information from '../widget/information'
import {request} from '../../network/request'
export default {
  name: 'lists',
  data () {
    return {
      cid: this.$route.query.cid,
      type: '4',
      total: 0,
      page: this.$route.query.page,
      data: {},
      loading: true,
      provincename: '',
      cityname: '',
      info_ad: '',
      fullscreenLoading: true
    }
  },
  components: {
    ListCity,
    information
  },
  watch: {
    '$route': {
      handler (newVal) {
        if (this.$route.query.cid) {
          this.cid = this.$route.query.cid
        } else {
          this.cid = 'all'
        }
        if (this.$route.query.t) {
          this.type = this.$route.query.t
        } else {
          this.type = '4'
        }
        if (this.$route.query.page) {
          this.page = this.$route.query.page
          this.getdata()
        } else {
          this.page = 1
          this.getdata()
        }
      }
    }
  },
  mounted () {
    // 判断是否get传入cid
    let cid = this.$route.query.cid
    // 如果有值
    if (cid && cid !== 'all') {
      let data = new URLSearchParams()
      data.append('cid', cid)
      request({
        url: '/api/cityname',
        method: 'post',
        data: data
      }).then(res => {
        this.cityname = res.data.city
        this.provincename = res.data.province
      }).catch(err => {
        console.log(err)
      })
      // 请求省份 城市名字
    } else {
      // 如果没值
      this.cid = 'all'
    }
    // this.ad()
    this.getdata()
    this.ad()
  },
  methods: {
    getcid (e) {
      this.cid = e
      this.getdata()
    },
    handleClick (tab) {
      this.$router.push({
        path: this.$route.path,
        query: {
          cid: this.$route.query.cid,
          t: tab.name
        }
      })
      this.type = tab.name
      this.page = 1
    },
    ad () {
      this.icon_ad = JSON.parse(localStorage.getItem('ad')).icon
      this.info_ad = JSON.parse(localStorage.getItem('ad')).info
    },
    getdata () {
      this.fullscreenLoading = true
      let data = new URLSearchParams()
      data.append('sort', this.type)
      data.append('cid', this.cid)
      data.append('page', this.page)
      request({
        url: '/api/lists',
        method: 'post',
        data: data
      }).then(res => {
        this.data = res.data.data
        if (this.data.length >= 6) {
          for (let item of this.info_ad) {
            let random = Math.round(Math.random() * (res.data.data.length - 1))
            this.data.splice(random, 1, item)
          }
        }
        this.total = res.data.count
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style>
.el-tabs__item{
  padding: 0 10px!important;
  font-size: 12px!important;
}
.el-tabs__item.is-disabled {
  color: #f39!important;
  font-size: 14px!important;
}
.el-tabs__nav-wrap::after {
  background-color:rgba(0,0,0,0)!important;
}
.el-tabs__nav {
  z-index: 0!important;
}
.el-tabs__header {
  margin: 0 0 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/lists.vue